// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfigActivator_container__DX6-d","label":"ConfigActivator_label__1DtEW"};